export { helpEditTopicsResource, portalsTopicsHiddenWarningResource } from './resources';
